import useCurrentUser from "hooks/fragments/useCurrentUser";
import useIsLoggedIn from "hooks/user/useIsLoggedIn";
import faBookOpen from "icons/solid/book-open.svg";

import MobileBottomNavLink from "./MobileBottomNavLink";

export default function MobileBottomNav(): JSX.Element {
  const isLoggedIn = useIsLoggedIn();
  const username = useCurrentUser(u => u?.username);

  return (
    <MobileBottomNavLink
      href={username && isLoggedIn ? `/@${username}/books` : "/join"}
      text="Library"
      icon={faBookOpen}
    />
  );
}
